import React, { useState, useEffect } from "react";
import InvoiceCard from "../component/InvoiceCard";
import DatePicker from "react-multi-date-picker";
import HistoryInovoiceTab from "../component/HistoryInovoiceTab";
import PreviousBar from "../component/PreviousBar"
import { TextField, Autocomplete } from '@mui/material';
import { getAllLotteries } from "../features/lotteryReducer";
import { useSelector, useDispatch } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { getHistoryHuay } from '../features/lotteryInvoice'


const Historylottery = () => {
  const [date, setDate] = useState(new Date());
  const dispatch = useDispatch()
  const historyHuays = useSelector(state => state.invoice.historyhuay)
  const [filter, setFilter] = useState("all")
  const [lotteryName, setLotteryName] = useState([])
  const [lottery, setLottery] = useState([])
  const [Data, setData] = useState({
    memberId: null,
    isWin: "all",
    pageNum: 1,
    pageSize: 12,
    lottery: "all"
  })
  const theme = createTheme({
    palette: {
      secondary: {
        // This is green.A700 as hex.
        main: '#000000 ',
      },
    },
  });
  useEffect(() => {
    let lotteryArr = ["ทั้งหมด"]
    async function fetchData() {
      // You can await here
      let lotto = await dispatch(getAllLotteries());
      let historyHuay = await dispatch(getHistoryHuay(Data))
      // console.log("lotto", lotto)
      lotto.map((data) => {
        // console.log(data)
        lotteryArr.push(data.lotteryName)
      }
      )
      setLotteryName(lotto)
      setLottery(lotteryArr)
    }
    fetchData();

  }, [])
  const moreData = () => {
    setData({ ...Data, pageSize: Data.pageSize + 12 ,lottery: filter})
  }
  useEffect(() => {
    dispatch(getHistoryHuay(Data))

  }, [Data])

  return (
    <div className="w-auto -md mt-5 pb-7 mx-0.5 text-[#b3853e]">
      {/* <p className="text-base font-bold ">ประวัติการสั่งซื้อ</p> */}
      <PreviousBar name="ประวัติการสั่งซื้อ"  toDashboard/>
      <div className=" border rounded border-[#b3853e] py-2 px-2">
        <div className="flex justify-end text-end text-base">
          {/* <p className="pt-0.5">เลือกงวด: </p>
          <DatePicker
            inputClass="w-auto text-center text-[#b3853e] bg-[#f8eede] rounded border border-[#b3853e] outline-none"
            format={"DD/MM/YYYY"}
            value={date}
            onChange={handleChange}
          /> */}
          {/* <p className="pt-0.5">เลือกประเภทหวย: </p> */}

          <Autocomplete
            id="combo-box-demo"
            options={lottery}
            onChange={(e) => {

              if (e.target.innerText === "ทั้งหมด" || e.target.innerText === undefined) {
                setFilter("all")
              } else {
                let fitler1 = lotteryName.find(data => data.lotteryName === e.target.innerText)
                setFilter(fitler1._id)
              }
            }}
            defaultValue={"ทั้งหมด"}
            sx={{ width: 280, color: "white", borderBlockColor: "#f8eede", backgroundColor: "#f8eede"}}
            renderInput={(params) =>
              <ThemeProvider theme={theme}>
                <TextField color="secondary"
                  variant="filled" {...params} label="เลือกประเภทหวย" />
              </ThemeProvider>
            }
          />
          {/* <DatePicker
            inputClass="w-auto text-center text-[#b3853e] bg-[#f8eede] rounded border border-[#b3853e] outline-none"
            format={"DD/MM/YYYY"}
            value={date}
            onChange={handleChange}
          /> */}
          {/* <select className="bg-transparent border border-[#b3853e] rounded ml-1 px-3 outline-none -moz-appearance-none">
            <option>XX/XX/XXXX</option>
          </select> */}
        </div>
        <p className="text-sm">จำนวน {historyHuays?.length} รายการ</p>
        <HistoryInovoiceTab historyData={filter === "all" || filter === undefined ? historyHuays : historyHuays.filter(data => data.lotteryId === filter)} />
        {historyHuays?.length === Data.pageSize ? (
          <div className="w-auto mx-5 mb-5">
            <button  onClick={moreData} className="border  border-[#b3853e] w-full py-2.5 text-center text-[#b3853e] text-base hover:opacity-50 md:px-8"
            >
              ดูเพิ่มเติม
            </button>
           
          </div>) :
          <></>}
        {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-2 place-items-center">
          <InvoiceCard />
          <InvoiceCard />
          <InvoiceCard />
        </div> */}
      </div>
    </div>
  );
};

export default Historylottery;
